import Vue from 'vue';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from "vee-validate/dist/locale/en.json";

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize({ en });

Object.keys(en.messages).forEach(key => extend(key, rules[key]));

extend('length', {
    message: 'The password must be at least {_field_} characters.'
});

extend('required', {
    message: (fieldName) => `${fieldName} field is required`
});

extend('min', {
    message: (fieldName, placeholders) =>
        `The ${fieldName} minimum length is ${placeholders.length}`
});

extend('max', {
    message: (fieldName, placeholders) =>
        `The ${fieldName} maximum length is ${placeholders.length}`
});

extend('email', {
    message: (fieldName) => `The ${fieldName} must be valid email`
});

extend('regex', {
    message: (fieldName) => `The ${fieldName} field format is invalid`
});

extend('alpha_num', {
    message: (fieldName) =>
        `The ${fieldName} field may only contain alphabetic characters or numbers`
});

extend('min_value', {
    message: (fieldName, placeholders) =>
        `The ${fieldName} must not be less than ${placeholders.min}`
});

extend('max_value', {
    message: (fieldName, placeholders) =>
        `The ${fieldName} must not be greater than ${placeholders.max}`
});

extend('us_phone_number', {
    validate: (value) =>  /^\+1\(\d{3}\)-\d{3}-\d{4}$/.test(value),
    message: (fieldName) => `The ${fieldName} must be valid ${fieldName.toLowerCase()}`
})

extend('zip', {
    validate: (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value),
    message: (fieldName) => `The ${fieldName} field format is invalid`
})
